<template>
  <div>
    <div class="element-box">
      <div class="element-content px-5 pb-5">
        <symForm :options="opt" :data="formData" v-on:sended="matchForm" :form="userForm" :formProcess="formProcess" v-if="userForm" />
      </div>
    </div>
  </div>
</template>

<script>
import Choices from 'choices.js'
import symForm from '@/components/form/symForm.vue'
export default {
  name: 'matchForm',
  components: { symForm },
  props: ['event'],
  data () {
    return {
      session: session,
      userLoader: true,
      t: this.$root.t,
      users: null,
      userId: this.$route.query.userId,
      regions: [],
      userGroup: [],
      breadcrumb: [],
      userOpened: false,
      userForm: null,
      formProcess: 0,
      opt: {
        region: {data: [], label: 'nationallity'},
        userGroup: {data: [], label: 'name'}
      },
      formData: []
    }
  },
  mounted () {
    this.matchForm();
  },
  methods: {
    async multiSelect () {

      setTimeout(() => {
        var e = document.getElementsByClassName("choicesx");
        for (var i = 0; i < e.length; i++){
          var name = e[i].getAttribute("name");

          var element = e[i];

          var example = new Choices(element, {
            removeItemButton: false,

          });
        }
      }, 500);


      //CKEDITOR.replaceAll();

    },
    async matchForm (data) {
      this.userForm = null;
      this.formProcess = 0;
      this.$bus.$emit('globalLoader', true);
      if(data) {
        //this.userForm = null;
        this.$http.post(bsapi+'api/v1/odd/market/'+this.event,
          data )
          .then(response => {

            this.userForm = response.body.result;
            this.formProcess = 200;

            swal('', this.t.processing.success, "success")
            this.$bus.$emit('globalLoader', false);
            this.multiSelect()

          }, response => {
            this.userForm = response.body.result;
            this.formProcess = 400;
            swal(this.t.processing.error, this.t.processing.check, "error")
            this.$bus.$emit('globalLoader', false);
          })

      } else {
        this.$http.get(bsapi+'api/v1/odd/market/'+this.event)
          .then(response => {

            this.userForm = response.body.result;
            this.formData = response.body.form_data;
            this.$bus.$emit('globalLoader', false);
            this.multiSelect()

          }, response => {
            this.$bus.$emit('globalLoader', false);
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/stats/match/marketForm.vue